
const SettingsStepLayout = ({description, renderChild}) => {
    return (
        <>
            <div className="settings-container">
                {
                    renderChild
                }
            </div>
        </>
    )
}

export default SettingsStepLayout